module.exports = __webpack_public_path__ + "media/src/images/icons/eye/opened-active-dc9bc0d1516256d44f6beeb10b05db2d.svg";